import { useQuery } from "react-query";
import React, { Suspense, useEffect, useRef, useState } from "react";
import withLayout from "../../../src/layouts/withLayout";
import VideoBreadcrumb from "@Components/movie/Details/VideoBreadcrumb";
import Introduction from "@Components/movie/Details/Introduction";
import Share from "@Components/movie/Details/Share";
import Headline from "@Components/movie/Details/Headline";
import SubscriptionPreside from "@Components/movie/Details/SubscriptionPreside";
import RecommendMovieList from "@Components/movie/Details/RecommendMovieList";

import YoutubeVideo from "@Components/youtube/YoutubeVideo";
import { g4 } from "../../utils/helper";
import { movie } from "@Api";
import { fetchV3Articles } from "@Services/article";
import { Skeleton } from "antd";

const ArticleKindsMovies = React.lazy(() => import("@Components/movie/Details/ArticleKindsMovies"));
const ArticleList = React.lazy(() => import("@Components/movie/Details/ArticleList"));
const Comment = React.lazy(() => import("@Components/movie/Details/Comment"));
const ArticleKinds = React.lazy(() => import("@Components/movie/Details/ArticleKinds"));
const HotVideoList = React.lazy(() => import("@Components/movie/Details/HotVideoList"));

const { fetchMovieInfo, fetchHotVideoList } = movie;
type TMovies = {};

let videoTarget: any = null;
let stayTime: any = null;

const PlayDetail: React.FC<TMovies> = ({ }) => {
  const getHeightRef = useRef(null);
  const [showButton, setShowButton] = useState(false);
  const [nextAutoPlay, setNextAutoPlay] = useState(false);
  const [offheight, setOffheight] = useState<number>(0);
  const initMovieInfo: any = {
    completeKinds: [],
    data: {
      brand_id: "",
      brands: [],
      cmt_num: "",
      content_type: "",
      fav_status: "",
      favorite_num: "",
      id: "",
      intro: "",
      kind_id: "",
      kinds: [],
      like_status: "",
      likes: "",
      link: "",
      link_url: "",
      publishedDate: "",
      subAutoType: [],
      sub_status: "",
      thumb: "",
      title: "",
      video_id: "",
      visits: "",
      movieCategoryInfo: {
        description: "",
        icon: "",
        label: "",
        lastUpdateTime: "",
        presenter: [],
        shareLink: "",
        shorts: "",
        title: "",
        total: "",
      },
    },
    dimension: {
      dv_auto_type: "",
      dv_brand: "",
      dv_content_type: "",
      dv_kind: "",
    },
    isActive: '',
    kinds: [],
    nav: {
      autoType: "",
      brand_id: "",
      brand_name: "",
      brand_url: "",
      kind_id: "",
      kind_name: "",
      kind_url: "",
    },
  }

  useEffect(() => {
    setTimeout(() => {
      setOffheight(getHeightRef.current ? (getHeightRef.current as any).getBoundingClientRect().height - 180 : 534);
    }, 2000);

  }, []);


  const { data: movieInfo = initMovieInfo } = useQuery(
    ["fetchMovieInfo", window.movie_id],
    async () => {
      try {
        const res = await fetchMovieInfo({ id: window.movie_id || 0, ads: 1 });
        return res
      } catch (error) {
        console.error(error);
      }
      return initMovieInfo;
    },
    { enabled: !!window.movie_id },
  );


  const handleScroll = () => {
    const scrollY = window.scrollY || document.documentElement.scrollTop;
    if (scrollY > 2000) {
      setShowButton(true);
    } else {
      setShowButton(false);
    }
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const handleChildClick = (e) => {
    videoTarget = e;
  };

  const handleUnload = () => {
    if (stayTime) {
      const stayDuration = Date.now() - stayTime;
      const currentTime = videoTarget ? parseInt(videoTarget.getCurrentTime()) : 0;
      g4("video_closed", {
        page: "影音詳情頁",
        spm: "",
        module: "播放頁",
        channel: "影音",
        element: "影音進度條",
        element_id: "影音進度條",
        progress_bar_duration: currentTime,
        timer_duration: Math.floor(stayDuration / 1000),
        object_id: window.movie_id || 0,
      });

      stayTime = Date.now();
    }
  };

  const onEntries = (data) => {
    g4("video_exposured", {
      page_name: "影音詳情頁",
      module: "熱門影片",
      element: "列表",
      element_id: "影音列表",
      object_type: "影音",
      object_id: data.id,
    });
  };

  const onClick = (data) => {
    g4("video_clicked", {
      page_name: "影音詳情頁",
      module: "熱門影片",
      element: "列表",
      element_id: "影音列表",
      object_type: "影音",
      object_id: data.id,
    });
  };

  useEffect(() => {
    // 当页面进入时记录开始时间
    stayTime = Date.now();

    window.addEventListener("scroll", () => handleScroll());
    window.addEventListener("beforeunload", () => handleUnload());
    return () => {
      window.removeEventListener("scroll", () => handleScroll());
      window.removeEventListener("beforeunload", () => handleUnload());
    };
  }, []);


  const { brands, kinds, movieCategoryInfo } = movieInfo?.data || {};

  return (
    <section>
      {!!movieInfo?.data ? <section className={"min-h-[700px] w-full mx-auto mb-20"} style={{ background: "radial-gradient(circle at 50%, #5c5c5c, #000000)" }}>
        <section className="w-[1190px] mx-auto">
          <VideoBreadcrumb brandName={brands?.[0] || ""} kindName={kinds?.[0] || ""} />
          <>
            <div className="w-[962px] relative inline-block group" ref={getHeightRef} style={{ color: "fade(#224C96, 70 %)" }}>
              <div id='YoutubeVideo' style={{ width: "962px", height: "544px" }}>
                <YoutubeVideo
                  style={{ width: "100%", height: "100%" }}
                  videoId={movieInfo?.data.video_id}
                  data={{ movieId: window.movie_id, ...movieInfo?.data }}
                  onChildClick={handleChildClick}
                  onEnd={() => {
                    setNextAutoPlay(true);
                  }}
                />
              </div>
              <Introduction
                data={movieInfo?.data}
                onChange={() => {
                  setTimeout(() => {
                    setOffheight(
                      getHeightRef.current ? (getHeightRef.current as any).getBoundingClientRect().height - 180 : 534,
                    );
                  }, 20);
                }}
              />
              <div
                style={{ transition: "0.5s ease-in-out" }}
                className="
                  w-0
                  h-[150px]
                  opacity-0
                  invisible
                  absolute left-0 top-[20%] text-center z-[999]
                  group-hover:w-[66px]
                  group-hover:opacity-100
                  group-hover:visible
                "
              >
                <Share data={movieInfo?.data} status='1' />
              </div>
              <div className="w-[962px] inline-block relative">
                <Headline data={movieInfo?.data} id={window.movie_id} model={"movie"} />
              </div>
            </div>
            <div className="w-[212px] ml-16 relative float-right">
              <SubscriptionPreside category_info={movieInfo?.data.movieCategoryInfo} />
              <RecommendMovieList info={movieInfo} height={offheight} nextAutoPlay={nextAutoPlay} />
            </div>
          </>
        </section>
      </section> : <Skeleton active className="min-h-[700px]" />}

      <Suspense fallback={<Skeleton active />}>
        <div className="w-[1190px] m-auto flex">
          <div className="w-[962px] inline-block">
            <ArticleKindsMovies
              kinds={[...(movieInfo?.completeKinds || []), ...(movieInfo?.kinds || [])]}
              category='影音詳細頁'
            />
            <ArticleList
              request={fetchV3Articles}
              params={{
                type: "1,2",
                limit: 20,
                kindId: movieInfo.data.kind_id,
                filterIds: window.movie_id || 0,
              }}
              info={movieInfo}
              category='影音詳細頁'
            />
            <Comment id={window.movie_id || 0} video_id={movieInfo?.data.video_id} />
          </div>
          <div className="w-[212px] ml-16">
            <ArticleKinds
              data={[...(movieInfo?.kinds || []), ...(movieInfo?.completeKinds || [])]}
              category='影音詳細頁'
              source={`影音${movieCategoryInfo?.title}-相關車款`}
            />
            <HotVideoList
              onEntries={onEntries}
              onClick={onClick}
              request={fetchHotVideoList}
              params={{ limit: 3, id: window.movie_id || 0 }}
            />
          </div>
          {showButton && (
            <div className="w-40 h-40 fixed right-40" onClick={scrollToTop}>
              <img src='https://photo.8891.com.tw/2022/10/11/1665454207847296.png' className="w-full h-full" />
            </div>
          )}
        </div>
      </Suspense>
    </section>
  );
};
withLayout({
  cmp: <PlayDetail />,
  params: {
    AdTopBanner: true,
    nav: "DefaultFixedNav",
    footer: "Footer",
  },
});
